// Permission name constants — values must match exactly what the backend returns
// from /admin/roles/permission/all → role.permissions[].name

export const PERMISSIONS = {
  // ── Already exist in the backend ─────────────────────────────────────────
  VIEW_TRANSACTIONS: 'Can view transactions',
  VIEW_CUSTOMER_PROFILE: 'Can view customers profile',
  VIEW_INVESTMENT_PORTFOLIO: "Can view transfers and customer's investment portfolio",
  EXPORT_TRANSACTIONS: 'Can export transaction data in PDF and CSV',
  CREATE_CUSTOMER: 'Can create new customer',
  MANAGE_USERS: 'Can manage and invite users',
  APPROVE_WITHDRAWALS: 'Can approve withdrawals',
  VIEW_LOAN_REQUESTS: 'Can view loan requests',
  EXPORT_LOAN_REQUESTS: 'Can export loan requests',
  APPROVE_LOANS: 'Can approve loans',
  REJECT_LOANS: 'Can reject loans',
  UPDATE_CUSTOMER_NAMES: 'Can update customer names',
  RETAG_REFERRALS: 'Can retag referrals',
  VIEW_REFERRAL_REWARDS: 'Can view referral rewards',
  MANAGE_REFERRAL_MILESTONES: 'Can manage referral milestones',
  MANAGE_LEADERBOARD_TIERS: 'Can manage leaderboard payout tiers',
  APPROVE_REFERRAL_REWARDS: 'Can approve referral rewards',
  REJECT_REFERRAL_REWARDS: 'Can reject referral rewards',
  RUN_LEADERBOARD_PAYOUT: 'Can run leaderboard payout job',

  // ── Need to be created on the backend and assigned to roles ──────────────
  VIEW_PENDING_WITHDRAWAL: 'Can view pending withdrawals',
  VIEW_TARGET_SAVINGS_PERFORMANCE: 'Can view target savings performance',
  VIEW_MERCHANT_APPROVAL: 'Can view merchant approvals',
  VIEW_OVERDRAFT: 'Can view overdraft requests',
  APPROVE_OVERDRAFT: 'Can approve overdraft requests',
  SET_OVERDRAFT_LIMIT: 'Can set overdraft limit',
  VIEW_CUSTOMER_LIMITS: 'Can view customer limits',
  VIEW_PERFORMANCE: 'Can view performance',
  VIEW_VERIFICATIONS: 'Can view customer verifications',
  VIEW_RATES: 'Can view rates',
  EDIT_RATES: 'Can edit rates',
  VIEW_PROVIDERS: 'Can view providers',
  TOGGLE_PROVIDER: 'Can toggle provider status',
  EDIT_INVESTMENT_SETTINGS: 'Can edit investment settings',
  APPROVE_FAILED_PAYOUT: 'Can approve failed payouts',
  ADD_TERMINAL: 'Can add terminal',
  ASSIGN_TERMINAL: 'Can assign terminal',
  MANAGE_ADMIN_SECURITY: 'Can manage security settings',
  VIEW_CUSTOMER_ACTIONS: 'Can manage customer profile',
  VIEW_CUSTOMER_AUTOMATION: 'Can automate customer transfers',
  APPROVE_TREEGAR_INVESTMENT: 'Can approve treegar investments',
  VIEW_BLACKLIST_ACTIONS: 'Can manage account blacklist',
  GENERATE_CUSTOMER_STATEMENT: 'Can generate customer statement',
  VIEW_FAILED_TRANSACTIONS: 'Can view failed transactions',
  REVERSE_FAILED_TRANSACTION: 'Can reverse failed transactions',
  MARK_TRANSACTION_SUCCESSFUL: 'Can mark failed transactions successful',
}
